module.exports = function() {
  return new Worker(__webpack_public_path__ + "aa7569f5792ecf1a7fac.worker.js");
};